<template>
    <div>
        <v-card class="mt-2">
            <v-flex>
                <v-layout row justify-space-between>
                    <v-card-title class="headline pb-2">Students</v-card-title>
                    <v-card-actions>
                        <v-btn
                            class="text-xs-right"
                            small
                            color="success"
                            @click="resetPrice"
                            >Reset Price</v-btn
                        >
                    </v-card-actions>
                </v-layout>
            </v-flex>
            <v-divider></v-divider>
            <v-list three-line>
                <div v-for="(student, index) in students">
                    <v-list-tile class="pa-3">
                        <v-flex xs12>
                            <v-flex xs12 class="pl-0">
                                <v-layout row class="mb-0">
                                    <v-list-tile-title
                                        v-if="!student.nonUTA"
                                        class="pb-5"
                                    >
                                        {{ student.engName }}
                                        -
                                        {{ student.hebName }}
                                        ({{ student.class
                                        }}<span
                                            class="text-danger"
                                            v-if="isOldClassInfo(student)"
                                            >{{
                                                " - Last Updated: " +
                                                    getYear(student.regID)
                                            }}</span
                                        >)
                                    </v-list-tile-title>
                                    <v-list-tile-title v-else class="pb-5 pt-2">
                                        <v-layout row class="pl-3 pt-2">
                                            <div>
                                                {{ student.engName }}
                                                -
                                                {{ student.hebName }}
                                                ({{ student.class }})
                                            </div>

                                            <div
                                                class="font-weight-medium ml-2 text-info"
                                            >
                                                Non UTA
                                            </div>

                                            <v-btn
                                                v-if="student.nonUTA"
                                                small
                                                outline
                                                color="success"
                                                class="ml-3 my-0"
                                                @click="editStudent(student)"
                                                >edit student</v-btn
                                            >
                                        </v-layout>
                                    </v-list-tile-title>
                                    <v-list-tile-action class="pa-0 ma-0">
                                        <v-layout row align-center>
                                            <v-spacer></v-spacer>
                                            <v-select
                                                hide-details
                                                class="pa-0 ma-0"
                                                :items="getClassList(student)"
                                                label="Class"
                                                ref="chosenClass"
                                                v-model="student.chosenClass"
                                                :rules="[
                                                    (value) =>
                                                        rules.required(
                                                            value,
                                                            student.duration,
                                                        ),
                                                ]"
                                                box
                                                item-text="`${data.item.grade} - ${data.item.teacher}`"
                                            >
                                                <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    {{ data.item.grade }} -
                                                    {{ data.item.teacher }}
                                                </template>
                                                <template
                                                    slot="item"
                                                    slot-scope="data"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="
                                                                `${
                                                                    data.item
                                                                        .grade
                                                                } - ${
                                                                    data.item
                                                                        .teacher
                                                                }`
                                                            "
                                                        >
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>
                                            </v-select>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout row justify-space-between>
                                    <v-list-tile-action>
                                        <v-layout row>
                                            <div>
                                                <v-radio-group
                                                    v-model="student.duration"
                                                    row
                                                    hide-details
                                                >
                                                    <v-radio
                                                        class="py-2 pr-2"
                                                        label="Full"
                                                        value="FULL"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="First Half"
                                                        value="HALF 1"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="Second Half"
                                                        value="HALF 2"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="Custom"
                                                        value="CUSTOM"
                                                        color="success"
                                                    ></v-radio>
                                                    <v-radio
                                                        class="pa-2"
                                                        label="None"
                                                        value="NONE"
                                                        color="success"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </div>

                                            <!-- <v-checkbox
                                                v-model="student.lunchDoc"
                                                class="ml-4 mt-2"
                                                label="Lunch Document"
                                                color="success"
                                            >
                                            </v-checkbox> -->
                                        </v-layout>
                                    </v-list-tile-action>
                                    <div v-if="!student.editingAmount">
                                        <v-layout row class="py-1">
                                            <v-card-title
                                                class="py-0"
                                                style="background-color: #FFF; border-style: solid; border-color: #5cb860;"
                                            >
                                                <div class="font-weight-medium">
                                                    ${{
                                                        getPaymentAmount(
                                                            student,
                                                        )
                                                    }}
                                                </div>
                                            </v-card-title>
                                            <v-card-actions class="py-0">
                                                <v-btn
                                                    @click="edit(student)"
                                                    flat
                                                    icon
                                                    class="text-xs-right"
                                                    color="success"
                                                >
                                                    <v-icon>mdi-pencil</v-icon>
                                                </v-btn>
                                            </v-card-actions>
                                        </v-layout>
                                    </div>
                                    <div v-else>
                                        <v-layout row>
                                            <v-text-field
                                                class="mr-3"
                                                label="Amount"
                                                placeholder="Amount"
                                                v-model="student.paymentAmount"
                                                type="number"
                                                prefix="$"
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                class="mr-1"
                                                @click="() => rollback(student)"
                                                small
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                @click="
                                                    student.editingAmount = false
                                                "
                                                small
                                                color="success"
                                            >
                                                save
                                            </v-btn>
                                        </v-layout>
                                    </div>
                                </v-layout>
                            </v-flex>
                            <v-layout
                                class="mt-5"
                                row
                                justify-start
                                v-if="student.duration == 'CUSTOM'"
                            >
                                <v-checkbox
                                    class="ma-0 pa-0 weeks-selection"
                                    v-for="(week, index) in dates.map(
                                        (d) => d.parshe,
                                    )"
                                    :key="week"
                                    :label="`${index + 1} ${week}`"
                                    value="1"
                                    color="success"
                                    v-model="
                                        student.explicitWeeks[
                                            getWeekProperty(index)
                                        ]
                                    "
                                ></v-checkbox>
                            </v-layout>
                        </v-flex>
                    </v-list-tile>
                    <v-divider v-if="index != students.length - 1" />
                </div>
            </v-list>
        </v-card>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                ref="newStudent"
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
    </div>
</template>
<script>
import { groupBy, onlyUnique, getDomain } from "../../utils/helpers.js";
import ky from "../../utils/ky.js";
import newStudent from "./newStudent.vue";

export default {
    props: {
        students: Array,
        classes: Array,
        girlsClasses: Array,
        dates: Array,
        gradesSetup: Array,
        account: Object,
    },
    components: {
        "new-student": newStudent,
    },
    data() {
        return {
            editingStudent: "",
            newStudentDialog: false,
            regID: "",

            rules: {
                required: (value, duration) => {
                    return duration == "NONE" || !!value || "Required.";
                },
            },
        };
    },
    async created() {
        //await this.loadRegID();
    },
    computed: {},
    methods: {
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        getWeekProperty(index) {
            const weekNumber = 1 + index;

            return "week" + weekNumber;
        },
        validate() {
            const validations = this.students.map((student, index) =>
                this.$refs.chosenClass[index].validate(true),
            );

            return validations.every(Boolean);
        },
        getClassList(student) {
            return student.class.startsWith("G")
                ? this.girlsClasses
                : this.classes;
        },
        isOldClassInfo(student) {
            const currentYear = new Date().getFullYear();

            return this.getYear(student.regID) < currentYear;
        },
        getYear(regID) {
            if (!regID) return;

            return regID.substr(2);
        },
        resetPrice() {
            this.students.forEach(
                (student) => (student.paymentAmount = student.price()),
            );
        },
        getPaymentAmount(student) {
            return student.paymentAmount || student.price();
        },
        edit(student) {
            student.editingAmount = true;
            student.originalAmount = student.paymentAmount || student.price();
            student.paymentAmount = student.paymentAmount || student.price();
        },
        rollback(student) {
            student.paymentAmount = student.originalAmount;
            student.editingAmount = false;
            student.originalAmount = 0;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        onNewStudentCreated(student) {
            const existing = this.students.find(
                (s) => s.studentID == student.studentID,
            );

            existing.engName = student.engName;
            existing.hebName = student.hebName;
            existing.dob = student.dob;
            existing.class = student.class;

            this.newStudentDialog = false;
        },
        editStudent(student) {
            this.$refs.newStudent.prefill(student);

            this.newStudentDialog = true;
        },
    },
};
</script>
<style>
.weeks-selection .v-input__slot {
    margin-bottom: 0px !important;
}
</style>
